/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
import CONFIG from "../../../config/config";

export const b2cPolicies = {
    names: {
      SignIn: CONFIG.VUE_APP_AZURE_SIGN_IN_FLOW,
      forgotPassword: CONFIG.VUE_APP_AZURE_PASSWORD_FLOW,
      changePassword: CONFIG.VUE_APP_AZURE_CHANGE_PASSWORD_FLOW
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://' +
        CONFIG.BASE_AZURE_TENANT_NAME +
          '.b2clogin.com/tfp/'+
          CONFIG.BASE_AZURE_TENANT_NAME +
          '.onmicrosoft.com/'+
          CONFIG.VUE_APP_AZURE_SIGN_IN_FLOW,
      },
      forgotPassword: {
        authority: 'https://' +
          CONFIG.BASE_AZURE_TENANT_NAME +
          '.b2clogin.com/tfp/'+
          CONFIG.BASE_AZURE_TENANT_NAME +
          '.onmicrosoft.com/'+
          CONFIG.VUE_APP_AZURE_PASSWORD_FLOW,
      },
      changePassword: {
        authority: 'https://' +
          CONFIG.BASE_AZURE_TENANT_NAME +
          '.b2clogin.com/tfp/'+
          CONFIG.BASE_AZURE_TENANT_NAME +
          '.onmicrosoft.com/'+
          CONFIG.VUE_APP_AZURE_CHANGE_PASSWORD_FLOW
      },
      linkOrUnlinkProvider: {
        authority: 'https://' +
          CONFIG.BASE_AZURE_TENANT_NAME +
          '.b2clogin.com/tfp/'+
          CONFIG.BASE_AZURE_TENANT_NAME +
          '.onmicrosoft.com/'+
          process.env.VUE_APP_AZURE_LINK_OR_UNLINK_PROVIDER_FLOW
      }
    },
    authorityDomain: CONFIG.BASE_AZURE_TENANT_NAME + ".b2clogin.com"
}
